import { render, staticRenderFns } from "./SwitchXTableFilter.vue?vue&type=template&id=45844f77"
import script from "./SwitchXTableFilter.vue?vue&type=script&lang=js"
export * from "./SwitchXTableFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports